import { RxCustomerAPI } from '@driftt/dapper'
import { fromJS } from 'immutable'
import { createAuthedHttpClient } from '@driftt/web-auth'
import { CONTACTS_API } from 'constants/ResourcesConstants'
import qs from 'qs'
import { Observable } from 'rxjs'

const ContactsApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: CONTACTS_API,
  },
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

export const api = {
  fetchRevealDataByIp(ip) {
    return RxCustomerAPI.get('/reveal', { ip }, { headers: { 'x-version': '2' }})
      .checkStatus()
      .mapResponse(fromJS)
  },
  fetchRevealData(options = {}) {
    return RxCustomerAPI.get('/reveal', options, { headers: { 'x-version': '2' }})
      .checkStatus()
      .mapResponse(fromJS)
  },

  fetchRevealDataBySourceProperties(options = {}) {
    const { endUserId } = options
    return RxCustomerAPI.get(`/end_users/${endUserId}`, { sourceProperties: true }, { headers: { 'x-version': '2' }})
      .checkStatus()
      .mapResponse(fromJS)
  },

  fetchDriftIntelByEndUserId({ endUserId }) {
    return Observable.from(ContactsApi.get(`/drift/intel?endUserId=${endUserId}`).then(res => res.data))
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/reveal/api.js